import { useNavigate } from 'react-router-dom';

const ULTIMA_ATUALIZACAO = '21 de junho de 2026';
const EMAIL_CONTATO = 'contato@bibliotecadebolso.app';

function Secao({ titulo, children }) {
  return (
    <section style={{ marginBottom: 36 }}>
      <h2 style={{ fontSize: 18, fontWeight: 800, color: '#211C2B', margin: '0 0 12px', lineHeight: 1.3 }}>
        {titulo}
      </h2>
      <div style={{ fontSize: 15, color: '#4A4458', lineHeight: 1.75 }}>
        {children}
      </div>
    </section>
  );
}

function Li({ children }) {
  return <li style={{ marginBottom: 6, paddingLeft: 4 }}>{children}</li>;
}

export default function TermosUso() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100dvh', background: '#FAF8F5', fontFamily: 'inherit' }}>
      {/* Header */}
      <div style={{ background: '#fff', borderBottom: '1px solid #EDE9F5', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 16, position: 'sticky', top: 0, zIndex: 10 }}>
        <button onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#5B3CE4', fontSize: 14, fontWeight: 700, padding: 0, display: 'flex', alignItems: 'center', gap: 6 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Voltar
        </button>
        <span style={{ fontSize: 15, fontWeight: 800, color: '#211C2B' }}>Termos de Uso</span>
      </div>

      {/* Conteúdo */}
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 24px 80px' }}>
        <div style={{ marginBottom: 40 }}>
          <h1 style={{ fontSize: 30, fontWeight: 800, color: '#211C2B', margin: '0 0 8px', lineHeight: 1.2 }}>
            Termos de Uso
          </h1>
          <p style={{ fontSize: 13, color: '#9A93A4', margin: 0 }}>
            Última atualização: {ULTIMA_ATUALIZACAO}
          </p>
        </div>

        <Secao titulo="1. Aceitação dos termos">
          <p>
            Ao criar uma conta ou usar o <strong>Biblioteca de Bolso</strong> (disponível em <strong>bibliotecadebolso.app</strong>), você concorda com estes Termos de Uso. Se não concordar com algum ponto, não utilize o serviço.
          </p>
          <p style={{ marginTop: 10 }}>
            Estes termos se aplicam a todos os usuários, independentemente do plano contratado (Gratuito ou Premium).
          </p>
        </Secao>

        <Secao titulo="2. O que é o Biblioteca de Bolso">
          <p>
            O Biblioteca de Bolso é uma plataforma que permite a leitores cadastrar seu acervo pessoal de livros e organizá-los empréstimos com outras pessoas. O app facilita o contato entre quem quer emprestar e quem quer ler, mas <strong>não é parte do acordo de empréstimo</strong> entre os usuários.
          </p>
          <p style={{ marginTop: 10 }}>
            Somos uma plataforma de conexão — não possuímos livros, não intermediamos entregas físicas e não nos responsabilizamos por eventuais danos, perdas ou atrasos nos empréstimos realizados entre usuários.
          </p>
        </Secao>

        <Secao titulo="3. Cadastro e conta">
          <p style={{ marginBottom: 12 }}>Para usar o Biblioteca de Bolso, você deve:</p>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <Li>Ter pelo menos 13 anos de idade.</Li>
            <Li>Fornecer informações verdadeiras e atualizadas no cadastro.</Li>
            <Li>Manter a confidencialidade da sua senha e ser responsável por toda a atividade realizada na sua conta.</Li>
            <Li>Notificar-nos imediatamente em caso de uso não autorizado da sua conta.</Li>
          </ul>
          <p style={{ marginTop: 12 }}>
            Reservamo-nos o direito de encerrar contas que violem estes Termos ou que apresentem comportamento prejudicial à comunidade.
          </p>
        </Secao>

        <Secao titulo="4. Uso permitido">
          <p style={{ marginBottom: 12 }}>Você pode usar o Biblioteca de Bolso para:</p>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <Li>Cadastrar livros do seu acervo pessoal e compartilhá-los com outros leitores.</Li>
            <Li>Solicitar e gerenciar empréstimos de livros com outros usuários.</Li>
            <Li>Participar de clubes de leitura, seguir outros leitores e explorar acervos.</Li>
            <Li>Avaliar livros e registrar seu histórico de leitura.</Li>
          </ul>
        </Secao>

        <Secao titulo="5. Uso proibido">
          <p style={{ marginBottom: 12 }}>É expressamente proibido:</p>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <Li>Cadastrar livros que você não possui ou não tem direito de emprestar.</Li>
            <Li>Usar o app para fins comerciais sem autorização, como venda de livros (exceto no contexto do Marketplace, quando disponível).</Li>
            <Li>Assediar, ameaçar ou discriminar outros usuários por qualquer motivo.</Li>
            <Li>Criar contas falsas ou se passar por outra pessoa.</Li>
            <Li>Tentar acessar áreas restritas do sistema, realizar engenharia reversa ou comprometer a segurança da plataforma.</Li>
            <Li>Usar o app para distribuir spam, conteúdo ilegal ou material protegido por direitos autorais sem autorização.</Li>
            <Li>Solicitar empréstimos sem intenção de devolução — o inadimplemento reiterado pode resultar no bloqueio da conta.</Li>
          </ul>
        </Secao>

        <Secao titulo="6. Empréstimos entre usuários">
          <p>
            O Biblioteca de Bolso facilita a conexão entre leitores, mas <strong>não é parte do contrato de empréstimo</strong>. O acordo de emprestar, receber, cuidar e devolver o livro é inteiramente entre os usuários envolvidos.
          </p>
          <p style={{ marginTop: 10 }}>
            O dono do livro tem o direito de recusar qualquer solicitação sem necessidade de justificativa. O leitor se compromete a devolver o livro nas condições combinadas e no prazo acordado.
          </p>
          <p style={{ marginTop: 10 }}>
            Em caso de não devolução ou dano ao livro, a resolução é de responsabilidade das partes. O Biblioteca de Bolso pode auxiliar com o histórico de transações, mas não possui poder coercitivo para garantir devoluções.
          </p>
        </Secao>

        <Secao titulo="7. Planos e pagamentos">
          <div style={{ background: '#F0ECFE', borderRadius: 14, padding: '16px 20px', marginBottom: 16 }}>
            <p style={{ fontWeight: 800, color: '#3F27B0', margin: '0 0 8px' }}>Plano Gratuito</p>
            <p style={{ margin: 0, color: '#4A4458' }}>
              Permite cadastrar livros, seguir outros leitores e realizar empréstimos básicos (até 2 empréstimos ativos simultaneamente). Sem custo e sem prazo de expiração.
            </p>
          </div>
          <div style={{ background: '#F0ECFE', borderRadius: 14, padding: '16px 20px' }}>
            <p style={{ fontWeight: 800, color: '#3F27B0', margin: '0 0 8px' }}>Plano Premium — R$ 29,90 (pagamento único)</p>
            <p style={{ margin: '0 0 8px', color: '#4A4458' }}>
              O Premium é um <strong>pagamento único e vitalício</strong>. Ao adquiri-lo, você desbloqueia permanentemente:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: '#4A4458' }}>
              <Li>Empréstimos simultâneos ilimitados.</Li>
              <Li>Participação em clubes de leitura ilimitados.</Li>
              <Li>Acesso ao Explorar com até 10 swipes por dia.</Li>
              <Li>Badge Premium visível no perfil.</Li>
            </ul>
            <p style={{ marginTop: 10, color: '#4A4458' }}>
              O acesso Premium está vinculado à sua conta. Em caso de exclusão da conta, o acesso é perdido sem direito a reembolso.
            </p>
          </div>

          <p style={{ marginTop: 16 }}>
            <strong>Reembolsos:</strong> por se tratar de acesso imediato a conteúdo digital, não oferecemos reembolso após a ativação do plano, exceto nos casos previstos no Código de Defesa do Consumidor (Lei nº 8.078/1990), como arrependimento em até 7 dias corridos da compra, desde que o acesso não tenha sido utilizado.
          </p>
          <p style={{ marginTop: 10 }}>
            Os pagamentos são processados pela Stripe, Inc., sujeitos aos termos e condições da Stripe.
          </p>
        </Secao>

        <Secao titulo="8. Conteúdo do usuário">
          <p>
            Você é responsável pelo conteúdo que publica no app (fotos, descrições de livros, avaliações, mensagens). Ao publicar conteúdo, você nos concede uma licença não exclusiva para exibi-lo aos demais usuários da plataforma.
          </p>
          <p style={{ marginTop: 10 }}>
            Não publique conteúdo ofensivo, discriminatório, ilegal ou que viole direitos de terceiros. Reservamo-nos o direito de remover conteúdo que viole estes Termos sem aviso prévio.
          </p>
        </Secao>

        <Secao titulo="9. Disponibilidade do serviço">
          <p>
            Nos esforçamos para manter o Biblioteca de Bolso disponível 24 horas por dia, mas não garantimos disponibilidade ininterrupta. Podemos realizar manutenções, atualizações ou desativar o serviço temporariamente sem aviso prévio.
          </p>
          <p style={{ marginTop: 10 }}>
            Reservamo-nos o direito de encerrar o serviço com aviso prévio de 30 dias. Nesse caso, usuários Premium terão direito a reembolso proporcional calculado sobre o valor pago.
          </p>
        </Secao>

        <Secao titulo="10. Limitação de responsabilidade">
          <p>
            O Biblioteca de Bolso é fornecido "como está". Não nos responsabilizamos por danos indiretos, incidentais ou consequentes decorrentes do uso do app, incluindo perda de livros, danos materiais resultantes de empréstimos ou interrupções do serviço.
          </p>
          <p style={{ marginTop: 10 }}>
            Nossa responsabilidade máxima em qualquer circunstância é limitada ao valor pago pelo usuário nos últimos 12 meses.
          </p>
        </Secao>

        <Secao titulo="11. Modificações nos termos">
          <p>
            Podemos atualizar estes Termos periodicamente. Alterações relevantes serão comunicadas pelo app ou por e-mail com antecedência mínima de 15 dias. O uso continuado após esse prazo constitui aceitação dos novos termos.
          </p>
        </Secao>

        <Secao titulo="12. Lei aplicável e foro">
          <p>
            Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca de domicílio do usuário para resolução de conflitos, conforme o Código de Defesa do Consumidor.
          </p>
        </Secao>

        <Secao titulo="13. Contato">
          <p>Em caso de dúvidas sobre estes Termos, entre em contato:</p>
          <div style={{ marginTop: 12, background: '#F0ECFE', borderRadius: 14, padding: '16px 20px' }}>
            <p style={{ margin: 0, fontWeight: 700, color: '#3F27B0' }}>Biblioteca de Bolso</p>
            <p style={{ margin: '4px 0 0' }}>
              <a href={`mailto:${EMAIL_CONTATO}`} style={{ color: '#5B3CE4', fontWeight: 600 }}>{EMAIL_CONTATO}</a>
            </p>
          </div>
        </Secao>
      </div>
    </div>
  );
}
